import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["component", "onLoad", "onError", "loadingComponent", "errorComponent"];
import { useCallback, useState } from 'react';
import UIImage from 'UIComponents/image/UIImage';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const noop = () => {};
const ImageLoader = _ref => {
  let {
      component: Component = UIImage,
      onLoad = noop,
      onError = noop,
      loadingComponent = /*#__PURE__*/_jsx(UILoadingSpinner, {
        grow: true,
        style: {
          position: 'absolute',
          top: 0
        }
      }),
      errorComponent = /*#__PURE__*/_jsx(_Fragment, {})
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const handleLoad = useCallback(() => {
    setIsLoading(false);
    onLoad();
  }, [onLoad]);
  const handleError = useCallback(e => {
    setHasError(true);
    onError(e);
  }, [onError]);
  if (hasError) {
    return errorComponent;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isLoading && loadingComponent, /*#__PURE__*/_jsx(Component, Object.assign({
      onError: handleError,
      onLoad: handleLoad
    }, props))]
  });
};
export default ImageLoader;